
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"id":"icon-search","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 64 64"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M26.3 10.08a16.2 16.2 0 11-11.47 4.75 16.1 16.1 0 0111.46-4.75m0-3a19.2 19.2 0 1013.54 5.62A19.15 19.15 0 0026.3 7.08z"}}),_c('path',{attrs:{"d":"M26.3 3a23.3 23.3 0 0116.45 39.75A23.3 23.3 0 019.82 9.82 23.13 23.13 0 0126.3 3m0-3a26.3 26.3 0 1018.57 7.7A26.2 26.2 0 0026.3 0zm25.85 48.53l8.14 8.14a2.5 2.5 0 010 3.54l-.1.1a2.5 2.5 0 01-3.57 0l-8.13-8.1 3.63-3.62m0-3.84a1 1 0 00-.68.3L45 51.47a1 1 0 000 1.35l9.6 9.6a5.5 5.5 0 007.77 0l.1-.1a5.5 5.5 0 000-7.78L52.82 45a1 1 0 00-.68-.28z"}}),_c('path',{staticClass:"svg-n svg-m",attrs:{"d":"M48.93 48.93l-4.3-4.3"}})])
          )
        }
      }
    